<script>
    import { createEventDispatcher } from "svelte";
    import Dropdown from "./Dropdown.svelte";

    export let items;
    export let values = [];

    const dispatch = createEventDispatcher();

    function addItem() {
        values = [...values, Object.keys(items)[0]];
        dispatchChange();
    }

    function removeItem(index) {
        values = values.filter((_, i) => i !== index);
        dispatchChange();
    }

    function updateItem(index, value) {
        values = values.map((v, i) => (i === index ? value : v));
        dispatchChange();
    }

    function dispatchChange() {
        dispatch('change', { data: values });
    }
</script>

<div class="space-y-2">
    {#each values as value, index}
        <div class="flex items-center space-x-2">
            <Dropdown bind:value={values[index]} {items} on:change={(e) => updateItem(index, e.detail.data)} />
            <button on:click={() => removeItem(index)} class="bg-red-500 text-white px-2 py-1 rounded">-</button>
        </div>
    {/each}
    <button on:click={addItem} class="bg-blue-500 text-white px-4 py-2 rounded">+</button>
</div>

<style>
    .space-y-2 > * + * {
        margin-top: 0.5rem;
    }
</style>
